module.exports = __webpack_public_path__ + "img/fm-Path 45 Copy@3x.db3616b3.png";